import { EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuCategory } from '../../../menu/menu-category.model';
import { MenuHoverEvent } from '../menu-hover-event.model';
import { PageGuideService } from '../../../../page-guide/page-guide.service';
var MenuButtonComponent = /** @class */ (function () {
    function MenuButtonComponent(router, pageGuideService) {
        this.router = router;
        this.pageGuideService = pageGuideService;
        this.isHovered = new EventEmitter();
    }
    MenuButtonComponent.prototype.ngOnInit = function () {
        this.userIsHovering = false;
        this.searchBarIsFocused = false;
    };
    MenuButtonComponent.prototype.showMenuOptions = function () {
        this.userIsHovering = true;
        this.isHovered.emit(new MenuHoverEvent(this.userIsHovering, false, this.searchBarIsFocused, this.menuIndex));
    };
    MenuButtonComponent.prototype.hideMenuOptions = function () {
        this.userIsHovering = false;
        this.isHovered.emit(new MenuHoverEvent(this.userIsHovering, false, this.searchBarIsFocused, this.menuIndex));
    };
    MenuButtonComponent.prototype.clickMenuOption = function () {
        if (this.userIsHovering) {
            this.hideMenuOptions();
        }
        else {
            this.showMenuOptions();
        }
    };
    MenuButtonComponent.prototype.chooseMenuOption = function () {
        if (!this.category) {
            return;
        }
        this.searchBarIsFocused = false;
        this.showMenuOptions();
    };
    Object.defineProperty(MenuButtonComponent.prototype, "name", {
        get: function () {
            if (!this.category)
                return '';
            return this.category.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuButtonComponent.prototype, "translationKey", {
        get: function () {
            if (!this.category)
                return '';
            return this.category.translationKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuButtonComponent.prototype, "hasOptions", {
        get: function () {
            if (!this.category)
                return false;
            if (!this.category.subMenus)
                return false;
            return this.category.subMenus.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuButtonComponent.prototype, "hoverConditions", {
        get: function () {
            if (this.searchBarIsFocused)
                return false;
            if (this.pageGuideService.isPageGuideActive && !this.isFullMenuGuied)
                return false;
            else if (this.pageGuideService.isPageGuideActive && this.isFullMenuGuied)
                return true;
            return (this.show && (this.show.panelIsHovered || this.show.buttonIsHovered) && this.show.index === this.menuIndex);
        },
        enumerable: true,
        configurable: true
    });
    return MenuButtonComponent;
}());
export { MenuButtonComponent };
